import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthModalProvider } from './contexts/AuthModalContext';
import { CoinToastProvider } from './contexts/CoinToastContext';
import { ErrorReportProvider } from './contexts/ErrorReportContext';
import { ChatInboxProvider } from './contexts/ChatInboxContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Mp3PlayerProvider, Mp3PlayerSkin } from './components/mp3-player';
import AppRouter from './router/AppRouter';
import { startEarnCatalogSync } from './utils/earnCatalogSync';
import { PageViewTracker } from './analytics/PageViewTracker';
import './App.css';

function App() {
  useEffect(() => startEarnCatalogSync(), []);
  return (
    <BrowserRouter>
      <PageViewTracker />
      <AuthProvider>
        <AuthModalProvider>
          <ThemeProvider>
            <CoinToastProvider>
              <ErrorReportProvider>
                <ChatInboxProvider>
                  <Mp3PlayerProvider>
                    <AppRouter />
                    <Mp3PlayerSkin />
                  </Mp3PlayerProvider>
                </ChatInboxProvider>
              </ErrorReportProvider>
            </CoinToastProvider>
          </ThemeProvider>
        </AuthModalProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
